import React from 'react';
import './SelectField.css';

const defaultOption = <option value="" className="hidden" key="default"></option>;

function SelectField({
                         fieldConfig,
                         value,
                         getCopy,
                         onFieldHide,
                         onFieldUpdate,
                         showValidationError,
                         hide = false,
                         disabled = false
                     }) {
    const hasASingleOption = !value && fieldConfig.options.length === 1;

    const options = fieldConfig.options.map((currentOption) => {
        return (
                <option
                    value={currentOption.id}
                    defaultValue={currentOption.isDefault}
                    key={currentOption.id}
                    lang={currentOption.lang}
                >
                    {currentOption.i18nKey && getCopy ? getCopy(currentOption.i18nKey) : currentOption.description}
                </option>
        );
    });
    !value && fieldConfig.options.length !== 1 && options.push(defaultOption);

    if (hide) {
        onFieldHide(fieldConfig.id);
    } else if (hasASingleOption) {
        onFieldUpdate(fieldConfig.id, fieldConfig.options[0].id, fieldConfig);
    }

    return (
            !hide && (
                    <label className={`SelectField-label${showValidationError ? ' SelectField-label--error' : ''}`}>
                        <span className="SelectField-title">{fieldConfig.label}</span>
                        <div className="SelectField-field-box">
                            <select
                                    value={value}
                                    className="SelectField-select"
                                    autoComplete="off"
                                    disabled={disabled}
                                    onChange={(event) => {
                                        onFieldUpdate(fieldConfig.id, event.target.value, fieldConfig);
                                    }}
                            >
                                {options}
                            </select>
                        </div>
                        <span className="SelectField-error-msg">{fieldConfig.errorMsg}</span>
                    </label>
            )
    );
}

export default SelectField;



// WEBPACK FOOTER //
// ./src/components/Form/SelectField.js